@if (sports.length) {
    <ms-scroll-adapter class="next-to-go-pills" [msScrollSelectedInView]="active?.id?.toString()">
        <div class="sports-tab-pills">
            @for (item of sports; track item.id) {
                <button ds-pill size="medium" [attr.data-menu-item-id]="item.id" [selected]="!!item.active" (click)="eventSelected(item)">
                    @if (item.icon) {
                        <vn-icon slot="start" size="16" [name]="item.icon" />
                    }
                    <span>{{ item.title }}</span>
                </button>
            }
        </div>
    </ms-scroll-adapter>
}
